<div class="paginator-wrapper" [class.loading]="loading">
  @if (showLabel) {
  <span class="paginator-label" [class.hide-in-mobile]="hideShopCategoryLabelsInMobile">
    @if(!loading){
    @if(inShop){
    @if(inShopCategoryDescription){

    <span> Showing: {{ currentPage * perPage + 1 }} -
      {{  totalResults < (currentPage + 1) * perPage ? totalResults : (currentPage + 1) * perPage }} out of
      {{totalResults}}
      @if (inShopCategoryDescription && !hideShopCategoryLabelsInMobile) {
      @if(searchTerm){ search results for <b>"{{searchTerm}}"</b>}
      @if(collection?.name){ in <b>"{{collection?.name}}"</b> category}
      @if(activeVehicle){ for your <b>{{activeVehicle.year}} {{activeVehicle.details?.manufacturer?.name}}
        {{activeVehicle.details?.model?.name}} {{activeVehicle.details?.modification?.name}}</b>}
      } </span>

    } @else {
    <span>

      Showing: {{ currentPage * perPage + 1 }} -
      {{ totalResults < (currentPage + 1) * perPage ? totalResults : (currentPage + 1) * perPage }} out of
      {{totalResults}}

    </span>
    }
    } @else {
    <span>
      Showing: {{ currentPage * perPage + 1 }} -
      {{ totalResults < (currentPage + 1) * perPage ? totalResults : (currentPage + 1) * perPage }} out of
      {{totalResults}}

    </span>
    }
    }
  </span>
  }
  <p-paginator #paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="perPage"
    [totalRecords]="totalResults" [showFirstLastIcon]="showFirstLastIcon" [alwaysShow]="true"></p-paginator>
</div>
